import { combineReducers } from 'redux';
import { SUBMODULE_NAME_BOOKMARKS, SUBMODULE_NAME_CORE } from './constants';
import coreReducer from './reducers/core';
import bookmarksReducer from './reducers/bookmarks';

const accountUnawareReducers = {
    [SUBMODULE_NAME_BOOKMARKS]: bookmarksReducer,
};

const accountAwareReducers = {
    [SUBMODULE_NAME_CORE]: coreReducer,
};

export default combineReducers({
    ...accountUnawareReducers,
    ...accountAwareReducers,
});
